import { Component, Input, OnInit } from '@angular/core';
import { LimitePagamentoEcgTerceiro } from 'src/app/model/limite-pagamento-ecg-terceiro';

@Component({
  selector: 'app-limite-pagamento-ecg-por-terceiros-listagem',
  templateUrl: './limite-pagamento-ecg-por-terceiros-listagem.component.html',
  styleUrls: ['./limite-pagamento-ecg-por-terceiros-listagem.component.scss'],
  standalone: false
})
export class LimitePagamentoEcgPorTerceirosListagemComponent {

  @Input() limites: LimitePagamentoEcgTerceiro[];
  @Input() dataHoraResultado: string;

}
